import type { ReactNode } from "react";
import "./Layout.css";

interface LayoutProps {
  children: ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
  return (
    <div className="layout">
      {/* Header temporarily disabled */}
      {children}
    </div>
  );
};

export default Layout;
